import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import { BackgroundWithCurve, BulletSection, CaseStudiesImageCard, CaseStudyHeading, Section } from '../../utils/CaseStudiesComponents';

// CaseStudy Component
const MedhaServo = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Medha Servo Drives',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Automotive & Transportation',
                path: '/industries/automotive-transportation',
              },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="flex justify-center items-center  bg-white shadow-[0px_0px_4px_1px_rgba(0,0,0,0.25)] h-20 w-32 md:h-20 md:w-20 lg:h-24 lg:w-24 rounded-lg">
              {/* Company Logo */}
              {imagePath?.MedhaLogo ? (
                <img
                  className="h-16 w-16 md:h-16 md:w-16 lg:h-20 lg:w-20 object-contain"
                  src={imagePath?.MedhaLogo}
                  alt="Medha Logo"
                />
              ) : (
                <span className="text-gray-400 text-xs">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-2 md:gap-5 justify-center">
              <CaseStudyHeading
                title="Medha Servo Drives"
                desc="Full dynamic motion simulator to train metro-rail Captains"
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {/* Play Icon */}
              {videoPath?.Medha && (
                <video
                  src={videoPath?.Medha}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Overview"
            content="Developed a dynamic motion simulator that supported 6DOF (Six Degrees of Freedom) for
            India based metro railways to train their Captains and Pilots. The objective of this project was to
            train their prospective Captains/Pilots on the entire track. As part of this program the
            Captains/Pilots will be trained on real-life scenarios that might be encountered on a daily basis
            and how to resolve them so that they are self-sufficient during the running of the train."
          />

          <Section
            title="Execution"
            content={[
              'Spatial Grid was engaged to design and develop the dynamic motion simulator system that cantrain the Captains/Pilots in an immersive and engaging manner. The Spatial Grid team designed the entire system that would interface with train’s hardware controls in real-time. This is to trainCaptains/Pilots to take corrective actions instantaneously enabled through muscle memory and retain the knowledge for a longer period of time.',
              'The full motion simulator system had several software and hardware interface components that provides view of the real environment. It simulates different weather environments, failure scenarios, day-light conditions and support for driving in both day and night. Software components developed are designed to be configurable dynamically for the instructor to train prospective Captains to face different situations',
              'One of the key components developed is to build additional scenarios and conditions dynamically for the administrator to extend functionality in future. Along with the simulator AR based digital manuals, immersive tutorials and CBT materials were delivered.',
            ]}
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.Medha1}
                title="MR Experience Interface"
              />
              <CaseStudiesImageCard
                image={imagePath?.Medha2}
                title="Loco Pilot Simulator Training"
              />
            </div>
          </div>

          <BulletSection
            introText="This projected involved development of the following components:"
            bulletPoints={[
              'MR based experience with real scene and CGI environment',
              'Pneumatic chair with supporting 6DOF (except yaw and surge as they are not big factors in the train movement)',
              'Interfacing with train control systems in real-time to synchronize the scene and pneumatic chair to provide the feedback',
              'Created digital twins to train Captains so that they are self-sufficient in resolving mechanical issues that might be encountered during running of the train',
              'Creation of simulation and scenarios dynamically configured by the instructor',
              'CBT material, AR based problem resolution, AR based digital manuals',
            ]}
            closingText="These features work together to create a robust ecosystem that not only addresses 
              current challenges but also anticipates future requirements. The result is a 
              comprehensive solution that drives transformation and delivers long-term value 
              across all levels of the organization."
          />

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              content="Organization was able to deliver the dynamic motion-based simulator in 6 months at
one-sixth of the prevailing industry cost thereby saving them money and delivering in time with
real-life environment with superior quality."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
<CaseStudyHeading />;
<CaseStudiesImageCard />;


export default MedhaServo;
